import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sarlaft-layout',
  templateUrl: './sarlaft-layout.component.html'
})
export class SarlaftLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
